import { ContractStatus } from '../../common/types'
import { Contract } from '../../common/validations'

const compareContractsByStartDate = (left: Contract, right: Contract) =>
  left.startDate.localeCompare(right.startDate)

export const orderContracts = (contracts: Contract[]) =>
  [...contracts].sort(compareContractsByStartDate)

export const getDefaultContract = (contracts: Contract[]) => {
  const activeContracts = contracts.filter(
    (contract) => contract.status === ContractStatus.ACTIVE
  )

  if (activeContracts.length > 0) {
    return orderContracts(activeContracts)[0]
  }

  return orderContracts(contracts)[0]
}
